import {React, ReactDOM, withStyles, StyledProps} from '@api'
import {Button, Dialog, Typography, DialogActions, DialogContent, DialogContentText} from '@material-ui/core'
import {observer} from 'mobx-react'
import * as css from './ConfirmationDialog.css'

interface MyProps {
  openConfirmDialog?: boolean,
  onCancel?: (e) => void,
  onClickConfirm?: (e) => void,
  message?: React.ReactNode,
  cancelLabel?: string,
  confirmationLabel?: string
  inProgress?: boolean
  skipConfirm?: boolean
  canConfirm?: boolean
  canCancel?: boolean
}

@observer
export class ConfirmationDialog extends React.Component<MyProps> {
  static defaultProps = {
    canConfirm: true,
    canCancel: true
  }

  componentWillMount(): void {
    const {props: {skipConfirm, onClickConfirm}} = this
    skipConfirm && onClickConfirm(null)
  }

  render(): React.ReactPortal {
    const {
      openConfirmDialog,
      onCancel,
      onClickConfirm,
      message,
      cancelLabel,
      confirmationLabel,
      inProgress,
      skipConfirm,
      canConfirm, canCancel,
      children
    } = this.props
    return skipConfirm ? null : ReactDOM.createPortal(
      <Dialog
        open={openConfirmDialog}
        className={css.root}
        classes={{
          paper: css.paper,
        }}
        onClose={onCancel}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent className={css.dialogContent}>
          {children ? children :
           <DialogContentText id='alert-dialog-description'>
             {!message ? 'Are you sure you want to delete this item?' : message}
           </DialogContentText>
          }
        </DialogContent>
        {canConfirm && <DialogActions className={css.actions}>
          {canCancel && <Button disableRipple onClick={onCancel}
			        color='secondary'>
				<Typography classes={{root: css.buttonText}}>{cancelLabel}</Typography>
			</Button>}
			<Button disableRipple disabled={inProgress} onClick={onClickConfirm} color={inProgress ? null : 'default'} autoFocus>
				<Typography classes={{root: css.buttonText}}>{confirmationLabel}</Typography>
			</Button>
		</DialogActions>}
      </Dialog>
      , document.body)
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ConfirmationDialog.tsx